<template>
  <gc-main-layout :title="title" :isXSmall="isXSmall" :isLarge="isLarge">
    <template #headerContent>
      <GcHeaderContentStatic title="almondco-inshell-receive-manifest" />
    </template>

    <DxToolbar class="view-toolbar">
      <DxItem #default location="center" locate-in-menu="never">
        <div class="toolbar-label">
          <b>almondco-inshell-receive-manifest</b>
        </div>
      </DxItem>
      <DxItem location="after"></DxItem>
    </DxToolbar>
  </gc-main-layout>
</template>

<script>
import BaseViewMixin from "../../v1/_mixins/base.view";

export default {
  props: {},
  mixins: [BaseViewMixin],
  components: {},
  data() {
    return {};
  },
  methods: {}
};
</script> 